/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StaffMemberRouteLinkItem from './StaffMemberRouteLinkItem';
import InstructionalMaterialsIcon from 'icons/InstructionalMaterialsIcon';
import {useUserContext} from 'app/UserContext';
import {useMidasJsonApi} from 'app/hooks';

const messages = defineMessages({
  title: {id: 'navigation.reviewer-materials'},
});

const ReviewerMaterialsItem = () => {
  const [{currentStaffID}] = useUserContext();

  const [response] = useMidasJsonApi({
    url: `/midas/rest/instructional-material-bid-cycle-reviewer?userID=${currentStaffID}`,
    expectedStatus: [200],
  });

  // If a BidCycleReviewer entity does not exist, do not show the Reviewer link (this item)
  if (response.status === 200 && response.json.reviewers.length < 1) {
    return null;
  }

  return (
    <StaffMemberRouteLinkItem
      iconBefore={InstructionalMaterialsIcon}
      route="midas/staff-member/instructional-materials/reviewer-materials"
      title={messages.title}
    />
  );
};

export default ReviewerMaterialsItem;
